import { RevenueTable } from './revenue-table';

export { RevenueTable };
